<template>
  <CollapseSection
    title="Corretoras"
    :expanded="expanded"
    :disabled="disabled"
    :loading="loading"
    section-id="corretoras"
    @toggleSection="$emit('toggleSection')"
  >
  <div class="pb-5">
        <div v-if="alertMessage">
            <b-alert show :variant="alertVariant">{{ alertMessage }}</b-alert>
        </div>
        
        <div class="d-flex mb-3 justify-content-end" v-if="editable">
            <button type="button" @click="$bvModal.show('modal-nova-corretora')"
                class="button btn btn-outline-secondary btn-sm">
                <i class="fa fa-plus mr-1"></i> Adicionar nova corretora
            </button>
        </div>
        <div class="row">
            <div class="col-12 col-lg-12">
                <table class="pretty font-14 list">
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Produtos Habilitados</th>
                            <th v-if="editable"></th>
                        </tr>
                    </thead>
                    <tbody v-if="!brokerInsuranceTypes.length">
                        <tr><td colspan="100%">Sem cadastros.</td></tr>
                    </tbody>
                    <tbody v-if="brokerInsuranceTypes.length">
                        <tr v-for="item in brokerInsuranceTypes" :key="item.broker_id">
                            <td>{{ item.broker_name }}</td>
                            <td>
                                <span v-for="type in item.insurance_types" :key="type.id"
                                    class="badge badge-secondary font-weight-normal text-uppercase font-12 rounded-pill mr-1">
                                    {{ type.name }}
                                </span>
                            </td>
                            <td class="text-right" v-if="editable">
                                <a @click="editBroker(item.broker_id)" data-toggle="tooltip" title="Editar Corretora"
                                    class="text-secondary mr-1">
                                    <i class="fas fa-pen mx-1 icon-btn"></i>
                                </a>
                                <a @click="openModalDeleteBroker(item)" data-toggle="tooltip" title="Excluir Corretora"
                                    class="text-secondary">
                                    <i class="fas fa-times mx-1 icon-btn"></i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    
    <broker-insurance-modal :brokerOptions="brokerOptions" :insuranceTypes="insuranceTypes"
        :initialForm="editingBroker" 
        :usedTypes="usedInsuranceTypeIds" :usedBrokerIds="brokerInsuranceTypes.map(r => r.broker_id)"
        @save-broker-insurance="storeBroker"
    />

    <div class="modal">
        <b-modal id="show-modal-del" ref="showModalDel" size="md" class="mt-4" hide-footer centered>
        <template #modal-title>Remover empresa</template>

        <div class="card card-termo-uso mb-3" v-if="brokerSelected">
            <p class="mb-4">Deseja remover a corretora <strong>{{ brokerSelected.broker_name }}</strong>, deste grupo econômico?</p>
        </div>
        <div class="row border-top py-4">
            <div class="col-12 col-lg-12 d-flex justify-content-between">
                <button @click="$bvModal.hide('show-modal-del')"
                    class="btn btn-outline-secondary btn-lg text-uppercase px-4 mr-1">
                    <span class="d-none d-md-inline-block"> Cancelar</span>
                </button>
                
                <button @click="removeBroker(brokerSelected.broker_id)" class="btn btn-primary btn-lg text-uppercase px-4"
                    data-toggle="modal">
                    Remover
                </button>
            </div>
        </div>
        </b-modal>
    </div>

  </CollapseSection>
</template>

<script>
import { CollapseSection } from '@/components';
import { BrokerInsuranceModal } from "@/components/Client";
import commonsService from "@/services/commons";
import brokerService from "@/services/broker";
import economicGroupService from "@/services/economic-group";

export default {
    components: {
        CollapseSection,    
        BrokerInsuranceModal,
    },
    props: {
        expanded: Boolean,
        disabled: Boolean,
        economicGroupID: String,
        editable: { type: Boolean, default: false }
    },
    data: () => ({
        loading: false,
        editingBroker: null,
        brokerInsuranceTypes: [],
        brokerOptions: [],
        insuranceTypes: [],
        usedInsuranceTypeIds: [],
        brokerSelected: null,
    }),
    created() {
        this.resetAlert();
        if (this.expanded) {
            this.findFirstTime();

            if (this.economicGroupID) {
                this.getEconomicGroupCompanies();
            }
        }
    },
    methods: {
        findFirstTime() {
            this.getInsuranceTypes();
            this.getBrokers();
        },
        getEconomicGroupCompanies() {
            this.loading = true;
            economicGroupService
                .getEconomicGroupBrokerInsuranceTypes( this.economicGroupID )
                .then((response) => {

                    if (response.data.error) {
                        this.showError(response.data.message);
                        return;
                    }
                    
                    this.setBrokerInsuranceTypesResponse(response.data);
                })
                .catch((error) => {
                    this.showError(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        setBrokerInsuranceTypesResponse(dataResponse) {
            this.brokerInsuranceTypes = dataResponse;

            this.usedInsuranceTypeIds = this.brokerInsuranceTypes.flatMap(item =>
                item.insurance_types.map(type => type.id)
            );
        },
        getInsuranceTypes() {
            commonsService
                .insuranceTypes()
                .then((response) => {
                    if (response.data.error) return;

                    this.insuranceTypes = (response.data || []).map((type) => ({
                        id: type.id,
                        name: type.name,
                    }));
                })
                .catch(() => {
                    this.showError("Não foi possível recuperar os tipos de seguro.");
                });
        },
        getBrokers() {
            brokerService.get().then((response) => {
                if (response.data.error) return;
                this.brokerOptions = response.data.map(broker => ({
                    value: broker.id,
                    text: `${broker.name} - ${broker.cnpj}`
                }));
            }).catch(() => {
                this.showError("Não foi possível recuperar a lista de corretores.");
            });
        },
        editBroker(brokerId) {
            const relation = this.brokerInsuranceTypes.find(r => r.broker_id === brokerId);
            if (!relation) return;

            this.editingBroker = {
                broker_id: relation.broker_id,
                insurance_type_ids: relation.insurance_types.map(t => t.id)
            };

            this.$bvModal.show('modal-nova-corretora');
        },
        storeBroker(data) {
            this.loading = true;
            economicGroupService
                .storeEconomicGroupBrokerInsuranceTypes(this.economicGroupID, data)
                .then((response) => {
                    if (response.data.error) {
                        return;
                    }

                    this.setBrokerInsuranceTypesResponse(response.data);
                })
                .catch(() => {
                    this.showError("Não foi possível executar a ação.");
                })
                .finally(() => {
                    this.loading = false;
                    this.$nextTick(() => {
                        this.$refs.modalCompany?.closeModal();
                    });
                });
        },
        openModalDeleteBroker(broker) {
            this.brokerSelected = broker;
            this.$refs.showModalDel.show();
        },
        removeBroker(brokerId) {
            economicGroupService
                .deleteEconomicGroupBroker(this.economicGroupID, brokerId)
                .then((response) => {
                    if (response.data.error) {
                        return;
                    }

                    this.setBrokerInsuranceTypesResponse(response.data);
                })
                .catch(() => {
                    this.showError("Não foi possível executar a ação.");
                })
                .finally(() => {
                    this.$bvModal.hide('show-modal-del');
                    this.brokerSelected = null;
                });
        },
        getBrokerInsuranceRelations() {
            return this.brokerInsuranceTypes.flatMap((relation) =>
                    relation.insurance_types.map((type) => ({
                    broker_id: relation.broker_id,
                    insurance_type_id: type.id
                }))
            );
        },
    },  
    watch: {
        expanded: function (value) {
            if (value) {
                this.resetAlert();
                this.getEconomicGroupCompanies();
                
                if (this.brokerOptions.length==0) {
                    this.findFirstTime();
                }
            }
        },
    }
}
</script>
<style>
</style>
